/* eslint-disable */
// http://bencentra.com/code/2014/12/05/html5-canvas-touch-events.html
let canvasUtil = {
  setCanvas: (parent, childId) => {
    let canvas = {}
    canvas.node = document.getElementById(childId)
    canvas.context = canvas.node.getContext('2d')
    canvas.node.style.position = 'absolute'
    // canvas.node.style.border = '1px solid red';
    canvas.node.style.zIndex = 10
    canvas.node.style.top = 0
    canvas.node.style.left = 0
    canvas.node.width = parent.clientWidth
    canvas.node.height = parent.clientHeight
    // console.log(canvas.node.height)
    return canvas
  },
  init: function(container, childId) {
    var canvas = this.setCanvas(container, childId);
    var rect = canvas.node.getBoundingClientRect();
    canvas.isClicked = false
    var ctx = canvas.context;
    var pos = { x: 0, y: canvas.node.height / 2 };
    let setPosition = function(e) {
        // console.log(e)
      pos.x = e.offsetX;
    }
    // bind mouse events
    let onMove = function(e) {
        if (!canvas.isDrawing) {
           return;
        }
        ctx.beginPath();
        ctx.lineWidth = 5;
        ctx.lineCap = 'round';
        ctx.strokeStyle = '#fffff';
        ctx.moveTo(pos.x, pos.y);
        setPosition(e)
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
    };
    canvas.node.onmousemove = onMove
    canvas.node.onmousedown = function(e) {
        canvas.isDrawing = true;
        setPosition(e)
    };
    canvas.node.onmouseup = (e) => {
        canvas.isDrawing = false;
    };
    // Set up touch events for mobile, etc
    canvas.node.addEventListener("touchstart", function (e) {
      let mousePos = getTouchPos(canvas.node, e);
      var touch = e.touches[0];
      console.log('touchstart', touch)
      var mouseEvent = new MouseEvent("mousedown", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.node.dispatchEvent(mouseEvent);
    }, false);
    canvas.node.addEventListener("touchend", function (e) {
      var mouseEvent = new MouseEvent("mouseup", {});
      canvas.node.dispatchEvent(mouseEvent);
    }, false);
    canvas.node.addEventListener("touchmove", function (e) {
      var touch = e.touches[0];
      var mouseEvent = new MouseEvent("mousemove", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.node.dispatchEvent(mouseEvent);
    }, false);

    // Get the position of a touch relative to the canvas
    function getTouchPos(canvasDom, touchEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    }
        // Prevent scrolling when touching the canvas
    document.body.addEventListener("touchstart", function (e) {
      if (e.target == canvas.node) {
        e.preventDefault();
      }
    }, { passive: false });
    document.body.addEventListener("touchend", function (e) {
      if (e.target == canvas.node) {
        e.preventDefault();
      }
    }, { passive: false });
    document.body.addEventListener("touchmove", function (e) {
      if (e.target == canvas.node) {
        e.preventDefault();
      }
    }, { passive: false });
  }
}

export {canvasUtil}



// WEBPACK FOOTER //
// ./src/utils.js